"use client";

import { c as _c } from "react/compiler-runtime";
import { closestCenter, DndContext, KeyboardSensor, PointerSensor, useSensor, useSensors } from "@dnd-kit/core";
import { arrayMove, SortableContext, sortableKeyboardCoordinates, useSortable, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { AlignHorizontalDistributeCenterIcon, AlignHorizontalDistributeEndIcon, AlignHorizontalDistributeStartIcon, GripVerticalIcon, Trash2Icon } from "lucide-react";
import { nanoid } from "nanoid";
import Image from "next/image";
import { useState } from "react";
import { useStoreBuilderContext } from "@/ui/admin/store-builder/store-builder-context";
import { useDidUpdate } from "@/ui/hooks/lifecycle";
import { useRouterRefresh } from "@/ui/hooks/use-router-refresh";
import { ImageUploadLight } from "@/ui/image-upload/image-upload-light";
import { Button } from "@/ui/shadcn/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/ui/shadcn/select";
import { useStartGlobalTransition } from "@/zustand/admin";
import { CompactButtonGroup } from "../../shared/compact-button-group";
import { LinkSelector } from "../../shared/link-selector";
export const GalleryForm = t0 => {
  const $ = _c(72);
  const {
    data
  } = t0;
  let t1;
  if ($[0] !== data?.photos) {
    t1 = data?.photos ?? [];
    $[0] = data?.photos;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [photos, setPhotos] = useState(t1);
  const context = useStoreBuilderContext();
  const refresh = useRouterRefresh();
  const startGlobalTransition = useStartGlobalTransition();
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      coordinateGetter: sortableKeyboardCoordinates
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const sensors = useSensors(useSensor(PointerSensor), useSensor(KeyboardSensor, t2));
  let t3;
  if ($[3] !== context || $[4] !== photos) {
    t3 = () => {
      context.saveSelectedPageSectionField({
        fieldPath: "photos",
        value: photos
      });
    };
    $[3] = context;
    $[4] = photos;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== photos) {
    t4 = [photos];
    $[6] = photos;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  useDidUpdate(t3, t4);
  let t5;
  if ($[8] !== photos) {
    t5 = event => {
      const {
        active,
        over
      } = event;
      if (!over) {
        return;
      }
      if (active.id !== over.id) {
        const oldIndex = photos.findIndex(photo => photo.id === active.id);
        const newIndex = photos.findIndex(photo_0 => photo_0.id === over.id);
        const updatedPhotos = arrayMove(photos, oldIndex, newIndex);
        setPhotos(updatedPhotos);
      }
    };
    $[8] = photos;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const handleDragEnd = t5;
  let t6;
  if ($[10] !== photos) {
    t6 = (id, updatedPhoto) => {
      const updatedPhotos_0 = photos.map(photo_1 => photo_1.id === id ? updatedPhoto : photo_1);
      setPhotos(updatedPhotos_0);
    };
    $[10] = photos;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const handlePhotoUpdate = t6;
  let t7;
  if ($[12] !== photos) {
    t7 = id_0 => {
      const updatedPhotos_1 = photos.filter(photo_2 => photo_2.id !== id_0);
      setPhotos(updatedPhotos_1);
    };
    $[12] = photos;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const handleDeletePhoto = t7;
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="text-xs text-neutral-600 font-medium">Columns</span>;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      value: "1",
      icon: <span className="text-xs font-medium">1</span>,
      tooltip: "1 column"
    };
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      value: "2",
      icon: <span className="text-xs font-medium">2</span>,
      tooltip: "2 columns"
    };
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      value: "3",
      icon: <span className="text-xs font-medium">3</span>,
      tooltip: "3 columns"
    };
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      value: "4",
      icon: <span className="text-xs font-medium">4</span>,
      tooltip: "4 columns"
    };
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = [t9, t10, t11, t12, {
      value: "6",
      icon: <span className="text-xs font-medium">6</span>,
      tooltip: "6 columns"
    }];
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  const t14 = data?.columns || 3;
  let t15;
  if ($[20] !== t14) {
    t15 = t14.toString();
    $[20] = t14;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== context || $[23] !== refresh || $[24] !== startGlobalTransition) {
    t16 = async value => startGlobalTransition(async () => {
      await context.saveSelectedPageSectionField({
        fieldPath: "columns",
        value: Number.parseInt(value)
      });
      await refresh();
    });
    $[22] = context;
    $[23] = refresh;
    $[24] = startGlobalTransition;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== t15 || $[27] !== t16) {
    t17 = <div className="grid gap-1">{t8}<CompactButtonGroup options={t13} defaultValue={t15} onValueChange={t16} className="w-full" /></div>;
    $[26] = t15;
    $[27] = t16;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <span className="text-xs text-neutral-600 font-medium">Item Distribution</span>;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  let t19;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = {
      value: "start",
      icon: <AlignHorizontalDistributeStartIcon className="size-3" />,
      tooltip: "Start"
    };
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = {
      value: "center",
      icon: <AlignHorizontalDistributeCenterIcon className="size-3" />,
      tooltip: "Center"
    };
    $[31] = t20;
  } else {
    t20 = $[31];
  }
  let t21;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = [t19, t20, {
      value: "end",
      icon: <AlignHorizontalDistributeEndIcon className="size-3" />,
      tooltip: "End"
    }];
    $[32] = t21;
  } else {
    t21 = $[32];
  }
  const t22 = data?.justifyItems ?? "space-between";
  let t23;
  if ($[33] !== context) {
    t23 = value_0 => {
      context.saveSelectedPageSectionField({
        fieldPath: "justifyItems",
        value: value_0
      });
    };
    $[33] = context;
    $[34] = t23;
  } else {
    t23 = $[34];
  }
  let t24;
  if ($[35] !== t22 || $[36] !== t23) {
    t24 = <div className="grid gap-1">{t18}<CompactButtonGroup options={t21} defaultValue={t22} onValueChange={t23} className="w-full" /></div>;
    $[35] = t22;
    $[36] = t23;
    $[37] = t24;
  } else {
    t24 = $[37];
  }
  let t25;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <span className="text-xs text-neutral-600 font-medium">Column Gap</span>;
    $[38] = t25;
  } else {
    t25 = $[38];
  }
  const t26 = data?.columnGap ?? "sm";
  let t27;
  if ($[39] !== context) {
    t27 = value_1 => {
      context.saveSelectedPageSectionField({
        fieldPath: "columnGap",
        value: value_1
      });
    };
    $[39] = context;
    $[40] = t27;
  } else {
    t27 = $[40];
  }
  let t28;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <SelectTrigger className="w-full"><SelectValue placeholder="Select gap size" /></SelectTrigger>;
    $[41] = t28;
  } else {
    t28 = $[41];
  }
  let t29;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <SelectContent><SelectItem value="sm">Small</SelectItem><SelectItem value="md">Medium</SelectItem><SelectItem value="lg">Large</SelectItem></SelectContent>;
    $[42] = t29;
  } else {
    t29 = $[42];
  }
  let t30;
  if ($[43] !== t26 || $[44] !== t27) {
    t30 = <div className="grid gap-1">{t25}<Select defaultValue={t26} onValueChange={t27}>{t28}{t29}</Select></div>;
    $[43] = t26;
    $[44] = t27;
    $[45] = t30;
  } else {
    t30 = $[45];
  }
  let t31;
  if ($[46] !== t17 || $[47] !== t24 || $[48] !== t30) {
    t31 = <div className="grid grid-cols-2 gap-2">{t17}{t24}{t30}</div>;
    $[46] = t17;
    $[47] = t24;
    $[48] = t30;
    $[49] = t31;
  } else {
    t31 = $[49];
  }
  let t32;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <span className="text-xs text-neutral-600 font-medium">Photos</span>;
    $[50] = t32;
  } else {
    t32 = $[50];
  }
  let t33;
  if ($[51] !== handleDeletePhoto || $[52] !== handleDragEnd || $[53] !== handlePhotoUpdate || $[54] !== photos || $[55] !== sensors) {
    t33 = photos.length > 0 && <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}><SortableContext items={photos.map(_temp)} strategy={verticalListSortingStrategy}><div className="space-y-1">{photos.map(photo_4 => <SortablePhotoItem key={photo_4.id} photo={photo_4} onPhotoUpdate={handlePhotoUpdate} onDeletePhoto={handleDeletePhoto} />)}</div></SortableContext></DndContext>;
    $[51] = handleDeletePhoto;
    $[52] = handleDragEnd;
    $[53] = handlePhotoUpdate;
    $[54] = photos;
    $[55] = sensors;
    $[56] = t33;
  } else {
    t33 = $[56];
  }
  let t34;
  if ($[57] !== photos) {
    t34 = photos.map(_temp2);
    $[57] = photos;
    $[58] = t34;
  } else {
    t34 = $[58];
  }
  let t35;
  if ($[59] !== photos) {
    t35 = newImages => {
      const reorderedPhotos = newImages.flatMap(newImageUrl => photos.find(photo_6 => photo_6.imageUrl === newImageUrl) ?? []);
      setPhotos(reorderedPhotos);
    };
    $[59] = photos;
    $[60] = t35;
  } else {
    t35 = $[60];
  }
  let t36;
  let t37;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = (image, t38) => {
      const {
        width,
        height
      } = t38;
      const newPhoto = {
        id: nanoid(),
        imageUrl: image,
        width,
        height
      };
      setPhotos(photos_0 => [...photos_0, newPhoto]);
    };
    t37 = image_0 => {
      setPhotos(photos_1 => photos_1.filter(photo_7 => photo_7.imageUrl !== image_0));
    };
    $[61] = t36;
    $[62] = t37;
  } else {
    t36 = $[61];
    t37 = $[62];
  }
  let t38;
  if ($[63] !== t34 || $[64] !== t35) {
    t38 = <ImageUploadLight maxImages={99} name="images" images={t34} onReorder={t35} onUpload={t36} onDelete={t37} />;
    $[63] = t34;
    $[64] = t35;
    $[65] = t38;
  } else {
    t38 = $[65];
  }
  let t39;
  if ($[66] !== t33 || $[67] !== t38) {
    t39 = <div className="mt-4"><div className="space-y-2">{t32}{t33}{t38}</div></div>;
    $[66] = t33;
    $[67] = t38;
    $[68] = t39;
  } else {
    t39 = $[68];
  }
  let t40;
  if ($[69] !== t31 || $[70] !== t39) {
    t40 = <div className="space-y-4">{t31}{t39}</div>;
    $[69] = t31;
    $[70] = t39;
    $[71] = t40;
  } else {
    t40 = $[71];
  }
  return t40;
};
function SortablePhotoItem(t0) {
  const $ = _c(38);
  const {
    photo,
    onPhotoUpdate,
    onDeletePhoto
  } = t0;
  let t1;
  if ($[0] !== photo.id) {
    t1 = {
      id: photo.id
    };
    $[0] = photo.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable(t1);
  let t2;
  if ($[2] !== transform) {
    t2 = CSS.Translate.toString(transform);
    $[2] = transform;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = isDragging ? 1 : 0;
  const t4 = isDragging ? 0.8 : 1;
  let t5;
  if ($[4] !== t2 || $[5] !== t3 || $[6] !== t4 || $[7] !== transition) {
    t5 = {
      transform: t2,
      transition,
      zIndex: t3,
      opacity: t4,
      position: "relative"
    };
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = transition;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const style = t5;
  let t6;
  if ($[9] !== onPhotoUpdate || $[10] !== photo) {
    t6 = link => {
      onPhotoUpdate(photo.id, {
        ...photo,
        link
      });
    };
    $[9] = onPhotoUpdate;
    $[10] = photo;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const handleLinkChange = t6;
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <GripVerticalIcon className="h-3 w-3 text-gray-400" />;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== attributes || $[14] !== listeners) {
    t8 = <div className="cursor-grab active:cursor-grabbing p-1 hover:bg-gray-100 rounded touch-none flex-shrink-0" {...attributes} {...listeners}>{t7}</div>;
    $[13] = attributes;
    $[14] = listeners;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== photo.imageUrl) {
    t9 = <div className="w-12 h-12 relative flex-shrink-0 rounded overflow-hidden bg-gray-100"><Image src={photo.imageUrl} alt="Gallery photo" fill={true} className="object-cover" sizes="48px" /></div>;
    $[16] = photo.imageUrl;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== photo.link) {
    t10 = typeof photo.link === "string" ? {
      type: "custom",
      url: photo.link
    } : photo.link;
    $[18] = photo.link;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== handleLinkChange || $[21] !== t10) {
    t11 = <LinkSelector value={t10} onChange={handleLinkChange} placeholder="Add link" compact={true} />;
    $[20] = handleLinkChange;
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== onDeletePhoto || $[24] !== photo.id) {
    t12 = () => onDeletePhoto(photo.id);
    $[23] = onDeletePhoto;
    $[24] = photo.id;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  let t14;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Trash2Icon className="h-3 w-3" />;
    t14 = <span className="sr-only">Delete photo</span>;
    $[26] = t13;
    $[27] = t14;
  } else {
    t13 = $[26];
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t12) {
    t15 = <Button size="sm" variant="ghost" onClick={t12} className="opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0 text-destructive hover:text-destructive hover:bg-destructive/10 h-7 w-7 p-0">{t13}{t14}</Button>;
    $[28] = t12;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== photo.id || $[31] !== setNodeRef || $[32] !== style || $[33] !== t11 || $[34] !== t15 || $[35] !== t8 || $[36] !== t9) {
    t16 = <div ref={setNodeRef} style={style} className="group p-2 flex items-center gap-2 bg-white border rounded hover:bg-gray-50 transition-colors" data-row-id={photo.id}>{t8}{t9}{t11}{t15}</div>;
    $[30] = photo.id;
    $[31] = setNodeRef;
    $[32] = style;
    $[33] = t11;
    $[34] = t15;
    $[35] = t8;
    $[36] = t9;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  return t16;
}
function _temp(photo_3) {
  return photo_3.id;
}
function _temp2(photo_5) {
  return photo_5.imageUrl;
}